<br><p-fieldset legend="Decretos de Nomeação" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="portariaNomeacaoAdm"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Atas" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="ataadministrativo"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Certificados" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="certificadosAdm"></app-lista-arquivos>
</p-fieldset>



